var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"hash-chart"},[_c('b-card',{staticClass:"text-center",attrs:{"title":"Daily Hashrate and Reward"}},[(_vm.dataCollection.labels)?_c('line-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.options}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }